import { SyncedCharacterController } from "../synced_character_controller";

export class PlayerHeadCharacterController extends SyncedCharacterController {

    constructor() {
        super();
    }
}